import OrganizationService from '../hydromet/organization/organization.service';
import {IUserApi} from '../api/user-api.service';
import IOrganizationApi from '../api/organization-api.service';
import {IUser, IOrganization, IChangePasswordData, IForecastType, IInvitationData} from '../api/api.types';
import {IImomoErrorService} from '../error/error.service';
import {IChangePasswordForm} from '../hydromet/userManagement/details/change-password-dialog.controller';

export interface IUserForm extends ng.IFormController {
  email: ng.INgModelController,
  fullName: ng.INgModelController,
  sourceId: ng.INgModelController,
  username: ng.INgModelController,
  role: ng.INgModelController,
  registeredOn: ng.INgModelController,
  phone: ng.INgModelController
}

export interface IOrganizationForm extends ng.IFormController {
  address: ng.INgModelController,
  city: ng.INgModelController,
  country: ng.INgModelController,
  email: ng.INgModelController,
  organization: ng.INgModelController,
  phone: ng.INgModelController,
  zipCode: ng.INgModelController,
}

const appSetupDialogTemplate = require<string>(
    './app-setup-dialog.html');

export class AppSetupDialog {
  static $inject = ['$mdDialog', 'organizationService', '$q', 'userApi', 'organizationApi', 'imomoErrorService'];

  private currentOrgId: number;
  private currentStepIndex: number = 0;
  private stepsCount: number = 3;
  private isStepOneValid: boolean;
  private userData: IUser;
  private changePasswordData: IChangePasswordData;
  private organizationData: IOrganization;
  private userForm: IUserForm;
  private changePasswordForm: IChangePasswordForm;
  private organizationForm: IOrganizationForm;
  private forecastTypes: {
    fiveDay: IForecastType,
    decadal: IForecastType,
    monthly: IForecastType
  };
  private seasonalForecastTypes: IForecastType[];
  private DialogParams: {
    wizardStep: number
  };
  private invitation: IInvitationData;
  private invitationList: IInvitationData[] = [];

  constructor (
  	private $mdDialog:ng.material.IDialogService,
  	private organizationService: OrganizationService,
  	private $q: ng.IQService,
  	private userApi: IUserApi,
  	private organizationApi: IOrganizationApi,
    private imomoErrorService: IImomoErrorService
  ) {
    this.organizationService.getCurrentOrgId()
  		.then(id => this.currentOrgId = id);

    if (this.DialogParams && this.DialogParams.wizardStep) {
      this.currentStepIndex = this.DialogParams.wizardStep;
    }
  }

  wizardStepValidation(stepIndex: number) {

    if (stepIndex == 0 && this.userForm && this.changePasswordForm) {

    	return 	this.userForm.$valid && this.changePasswordForm.$valid ||
	    		this.userForm.$valid &&
		    	(
		    	!this.changePasswordForm.oldPassword.$modelValue &&
		    	!this.changePasswordForm.newPassword.$modelValue &&
		    	!this.changePasswordForm.repeatNewPassword.$modelValue
		    	);
    } else if (stepIndex === 1 && this.organizationForm) {
    	return this.organizationForm.$valid
    } else if (stepIndex === 2) {
      return true;
    } else if (stepIndex === 3) {
      return true;
    }
    
    return false;
  }

  onWizardFinish() {
  	let promises: ng.IPromise<any>[] = [];
    let forecastTypes: IForecastType[] = [];
  	let userPromise = 
	  	this.userApi.saveUser(this.userData);

	  promises.push(userPromise);

  	if (this.changePasswordData &&
  		this.changePasswordData.oldPassword &&
  		this.changePasswordData.newPassword1 &&
  		this.changePasswordData.newPassword2
  	) {
  		let changePasswordPromise = 
  	  	this.userApi.changePassword(this.changePasswordData);
  	  	promises.push(changePasswordPromise);
  	}
  	
    this.organizationData.setupFinished = true;

  	let organizationPromise = 
  		this.organizationApi.saveOrganization(this.organizationData);

  	promises.push(organizationPromise);

    if (typeof this.forecastTypes.fiveDay.issueDateOffset !== 'undefined') {
      forecastTypes.push(this.forecastTypes.fiveDay)
    }

    if (typeof this.forecastTypes.decadal.issueDateOffset !== 'undefined') {
      forecastTypes.push(this.forecastTypes.decadal)
    }

    if (typeof this.forecastTypes.monthly.issueDateOffset !== 'undefined') {
      forecastTypes.push(this.forecastTypes.monthly)
    }

    forecastTypes.concat(this.seasonalForecastTypes)
      .forEach((forecastType: IForecastType) => {
        if(!forecastType.id) {
          promises
            .push(this.organizationApi.createForecastType(this.currentOrgId, forecastType));
        } else {
          promises
            .push(this.organizationApi.updateForecastType(this.currentOrgId, forecastType));
        }
      });

    this.invitationList.forEach((invitation) => {
      promises.push(this.userApi.sendInvitation(invitation));
    });

  	this.$q.all(promises)
  		.then(
  	    (
          // [
          // 	userPromiseResponse, 
          // 	changePasswordPromiseResponse, 
          // 	organizationPromiseResponse
          // ]
        ) => {
          this.$mdDialog.hide();
  	    }).catch((error: ng.IHttpPromiseCallbackArg<any>) => {
          this.imomoErrorService.showErrorDetailsDialog(error.data.details)
            .then(() => {
              this.$mdDialog.show({
                template: appSetupDialogTemplate,
                controller: AppSetupDialog,
                bindToController: true,
                controllerAs: '$ctrl'
              }).then(() => {
                
              });
            });
  	    });
  	
  }

  addToInvitationList(invitation: IInvitationData) {
    this.invitationList.push(invitation);
    this.invitation = null;
  }

  removeInvitation($index: number) {
    this.invitationList.splice($index, 1);
  }

  onCancelClick() {
  	this.$mdDialog.cancel();
  }

}




/** WEBPACK FOOTER **
 ** ./app/login/app-setup-dialog.controller.ts
 **/